import React from 'react'
import { paginationProps, selectProps, renderName, renderExists, $type } from '../util'
import { List, Edit, Datagrid, ReferenceField, TextField, DateField, FunctionField,
  Create, SelectInput, ReferenceInput, Show, SimpleShowLayout, EmailField, NumberField,
  TextInput, SimpleForm, Filter, EditButton, NumberInput, DeleteButton, Button, FormDataConsumer, BooleanField, required } from 'react-admin'
import { DateInput } from 'react-admin-date-inputs'
import { gender } from 'common/variables'
import app from 'common/client/app'
const validateRequired = [required()]
const PatientTitle = ({ record }) => {
  let name = renderName()(record)
  return <span>{ name || 'Patient' }</span>
}

export const PatientList = (props) => (
  <List title="Patients" {...props} bulkActionButtons={false} filters={ <PatientFilter /> } {...paginationProps} filterDefaultValues={{ deletedAt: { $type: $type.null } }}>
    <Datagrid rowClick="show">
      <TextField label="Patient ID" source="patientID" />
      <FunctionField label="Name" source="name" render={renderName()} />
      <DateField label="Date of Birth" source="dob" />
      <TextField label="Email" source="email" />
      <DateField label="Waiver Signed" source="waiverSignedAt" />
      <ReferenceField label="Customer" source="group" reference="group">
        <TextField source="title" />
      </ReferenceField>
      <EditButton />
      <DeleteButton undoable={false} />
    </Datagrid>
  </List>
)

export const PatientShow = props => (
  <Show title={<PatientTitle />} {...props}>
    <SimpleShowLayout>
      <FormDataConsumer>
        {({ formData, ...rest }) => !formData.user &&
        <Button onClick={ async () => {
          let user = await app.service('user').create({
            name: {
              given: formData.name.given,
              family: formData.name.family,
            },
            email: formData.email
          })
          app.service('patient').patch(formData.id, {
            user: user._id
          })
          window.location.reload()
        }}
        label = 'Create User'
        />
        }
      </FormDataConsumer>
      <TextField label="Patient ID" source="patientID" />
      <FunctionField label="Name" source="name" render={renderName()} />
      <TextField label="Nickname" source="nickname" />
      <DateField label="Date of Birth" source="dob" options={{ year: 'numeric', month: 'long', day: 'numeric' }} />
      <EmailField label="Email" source="email" />
      <ReferenceField label="Customer" source="group" reference="group">
        <TextField source="title" />
      </ReferenceField>
      <NumberField label="Phone" source="phone" />
      <TextField label="Gender" source="gender" />
      <NumberField label="Height" source="height" />
      <NumberField label="Weight" source="weight" />
      <DateField label="Waiver Signed" source="waiverSignedAt" options={{ year: 'numeric', month: 'long', day: 'numeric' }} />
      <BooleanField label="Email Permission: AllCore 360 Rides" source="emailPermission.rideComplete" />
      <BooleanField label="Email Permission: Core Evaluations" source="emailPermission.evalComplete" />
      <ReferenceField label="User" source="user" reference="user" allowEmpty>
        <FunctionField render={renderExists()} />
      </ReferenceField>
      <a href={`${process.env.REACT_APP_MANAGE_URL}rider/${props.id}/overview`} rel="noopener noreferrer" target="_blank">View Rider in Manage</a>
    </SimpleShowLayout>
  </Show>
)

export const PatientEdit = (props) => (
  <Edit title={'Edit Patient Information'} undoable={false} {...props}>
    <SimpleForm>
      <TextInput source="name.given" label="First Name" validate={validateRequired} />
      <TextInput source="name.family" label="Last Name" validate={validateRequired} />
      <TextInput source="email" label="Email" validate={validateRequired} />
      <ReferenceInput label="Customer" source="group" reference="group" {...selectProps}>
        <SelectInput optionText="title" optionValue="_id" />
      </ReferenceInput>
      <DateInput source="dob" label="Birthday" options={{ clearable: true, format: 'MMMM dd, yyyy' }} />
      <TextInput source="patientID" label="Patient ID" />
      <TextInput source="phone" label="Phone" />
      <SelectInput source="gender" label="Gender" choices={gender}/>
      <NumberInput source="height" label="Height"/>
      <NumberInput source="weight" label="Weight"/>
      <TextInput source="nickname" label="Nickname" />
      <TextInput label="Archived On" source="deletedAt" />
    </SimpleForm>
  </Edit>
)

export const PatientCreate = (props) => (
  <Create title={'Create Patient'} {...props}>
    <SimpleForm>
      <TextInput source="name.given" label="First Name" validate={validateRequired} />
      <TextInput source="name.family" label="Last Name" validate={validateRequired} />
      <TextInput source="email" label="Email" validate={validateRequired} />
      <ReferenceInput label="Customer" source="group" reference="group" {...selectProps} validate={validateRequired}>
        <SelectInput optionText="title" optionValue="_id" />
      </ReferenceInput>
      <DateInput source="dob" label="Birthday" options={{ clearable: true, format: 'MMMM dd, yyyy' }} />
      <TextInput source="patientID" label="Patient ID" />
      <TextInput source="phone" label="Phone" />
      <SelectInput source="gender" label="Gender" choices={gender}/>
      <NumberInput source="height" label="Height"/>
      <NumberInput source="weight" label="Weight"/>
      <TextInput source="nickname" label="Nickname" />
    </SimpleForm>
  </Create>
)

export const PatientFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Name Search" source="$text[$search]" alwaysOn />
    <TextInput label="Email Search" source="email" alwaysOn />
    <ReferenceInput label="Customer" source="group" reference="group" alwaysOn {...selectProps}>
      <SelectInput optionText="title" optionValue="_id" />
    </ReferenceInput>
    <SelectInput label="Status" source="deletedAt[$type]" choices={[
      { id: $type.null, name: 'Active' },
      { id: $type.date, name: 'Archived' },
    ]} alwaysOn required/>
  </Filter>
)

export default {
  PatientList,
  PatientEdit,
  PatientCreate,
  PatientFilter,
}
